/* eslint-disable react/jsx-pascal-case */
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import ShowNavbar from "./component/ShowNavbar/ShowNavbar";
import TopNavbar from "./component/TopNavbar/TopNavbar";
import Header from "./component/Header/Header";
import Footer from "./component/Footer/Footer";

// Lazy-loaded components
const Home = lazy(() => import("./pages/Home/Home"));
const About = lazy(() => import("./pages/About/About"));
const Activity_Adventure = lazy(() => import("./pages/Activity/Activity_Adventure"));
const Photos_Video = lazy(() => import("./pages/Photo_Video/Photos_Video"));
const Offer_Prices = lazy(() => import("./pages/Offer_Prices/Offer_Prices"));
const SignIn = lazy(() => import("./component/SignIn/SignIn"));
const Register = lazy(() => import("./component/Register/Register"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const NotFound = lazy(() => import("./pages/PageNotFound/NotFound"));
import Loader from "./component/loader/Loader.jsx"
import ScrollToTop from "./component/ScrollToTop/ScrollToTop.jsx.jsx";
function App() {
  return (
    <div>
      <ShowNavbar>
        {/* <TopNavbar /> */}
        <Header />
      </ShowNavbar>
        <ScrollToTop />

      {/* Wrap Routes with Suspense for fallback loading UI */}
      <Suspense fallback={<Loader/>}>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route path="/activity_adventure" element={<Activity_Adventure />} />
          <Route path="/photo_videos" element={<Photos_Video />} />
          <Route path="/offer_prices" element={<Offer_Prices />} />
          <Route path="/sign_in" element={<SignIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </Suspense>

      <ShowNavbar>
        <Footer />
      </ShowNavbar>
    </div>
  );
}

export default App;
